export const categories = [
  {
    slug: "romance",
    name: "浪漫爱情",
    description: "精选适合夫妻情侣共同观看的浪漫爱情电影，感受爱的甜蜜与感动",
    icon: "ri-heart-line",
  },
  {
    slug: "comedy",
    name: "轻松喜剧",
    description: "让欢笑充满二人世界，精选搞笑轻松喜剧电影推荐",
    icon: "ri-emotion-laugh-line",
  },
  {
    slug: "drama",
    name: "情感剧情",
    description: "深入人心的情感剧情片，与爱人一起感受人生百味",
    icon: "ri-movie-line",
  },
  {
    slug: "classic",
    name: "经典重温",
    description: "历久弥新的经典佳作，与另一半重温银幕经典时刻",
    icon: "ri-vip-crown-line",
  },
  {
    slug: "latest",
    name: "最新推荐",
    description: "最新上线的夫妻必看影视推荐，紧跟热门观影潮流",
    icon: "ri-fire-line",
  },
];